export const TYPES = ["KLUBB", "BEDRIFT", "FORENING", "PERSON", "ANNET"];
export const TYPE_LABELS = {
  KLUBB: "Klubb/lag",
  BEDRIFT: "Bedrift",
  FORENING: "Forening",
  PERSON: "Person/familie",
  ANNET: "Annet",
};

const EXPIRING_SOON_DAYS = 60;

export function getAgreementStatus(expiryDate) {
  if (!expiryDate) {
    return { key: "LOPENDE", label: "Løpende", cls: "bg-gray-100 text-gray-600" };
  }
  const now = new Date();
  const expiry = new Date(expiryDate);
  const msUntilExpiry = expiry.getTime() - now.getTime();

  if (msUntilExpiry < 0) {
    return { key: "UTLOPT", label: "Utløpt", cls: "bg-red-100 text-red-700" };
  }
  if (msUntilExpiry <= EXPIRING_SOON_DAYS * 24 * 60 * 60 * 1000) {
    return { key: "UTLOPER_SNART", label: "Utløper snart", cls: "bg-amber-100 text-amber-700" };
  }
  return { key: "AKTIV", label: "Aktiv", cls: "bg-green-100 text-green-700" };
}

export function formatDate(date) {
  if (!date) return "";
  return new Date(date).toLocaleDateString("nb-NO");
}
